<template>
    <div>
        <el-checkbox v-model="check" v-on:change="updateStore">{{ $l10n.__('Rapprocher') }}</el-checkbox>
    </div>
</template>

<script>
import Store from './../../store/reconciliation.js'

export default {
    props : ['default', 'document', 'reference', 'amount', 'deadlines'],
    data() {
        return {
            sharedState: Store.state,

            check: this.default,
            uniqueId: ''
        }
    },
    methods:{
        updateStore: function (check) {

            if (this.deadlines.length == 0) {
                Push.error(this.$l10n.__("Aucune échéance n'est sélectionnée"))
                this.check = false
                return
            }

            if (check) {
                const reconciliation = {
                    id: '_' + Math.random().toString(36).substr(2, 9),
                    ref: this.reference,
                    date: this.sharedState.transactionDate,
                    amount: this.amount,
                    document: this.document,
                    deadlines: this.deadlines,
                }

                Store.addReconciled(reconciliation)
                this.uniqueId = reconciliation.id
                this.$emit('new-payment-confirmed')
            } else {
                Store.delReconciled(this.uniqueId)
                this.uniqueId = ''
            }
        }
    }
}
</script>
